<template>
  <mt-popup v-model="isShowCity" class="city-picker" position="bottom">
    <div class="city-picker__top">
      <div @click="cancel">取消</div>
      <div @click="confirm">确定</div>
    </div>
    <div class="city-picker__main">
      <mt-picker :slots="slots" valueKey="name" @change="onCityChange"></mt-picker>
    </div>
  </mt-popup>
</template>
<script>
import _ from 'lodash';
import * as basicsApis from 'apis/basics';

/* 当前版本 mt-picker 的setSlotValue 以及setValues 有bug  所以使用了defaultIndex */
export default {
  props: ['isShow', 'data'],
  data() {
    return {
      isShowCity: false,
      isEdit: false,
      slots: [
        {
          flex: 1,
          values: [],
          className: 'city-picker__slot',
        }, {
          divider: true,
          content: '-',
          className: '',
        }, {
          flex: 1,
          values: [],
          className: 'city-picker__slot',
        }, {
          divider: true,
          content: '-',
          className: '',
        }, {
          flex: 1,
          values: [],
          className: 'city-picker__slot',
        },
      ],
      province: null,
      city: null,
      district: null,
      oldGbType: 1,
      nowGbType: 0,
    };
  },
  watch: {
    data: {
      handler(val) {
        const { province, gbType } = _.cloneDeep(val);
        this.oldGbType = gbType;
        if (province && province.id && this.oldGbType === 1) {
          this.isEdit = true;
        }
      },
      immediate: true,
    },
    isShow: {
      handler(val) {
        this.isShowCity = _.cloneDeep(val);
        if (val) {
          this.fetchProvince();
        }
      },
      immediate: true,
    },
    isShowCity: {
      handler(val) {
        this.$emit('changeVisible', val);
      },
      immediate: true,
    },
    province: {
      handler(val) {
        if (val && val.id) {
          this.fetchRegion('city', val.id);
        }
      },
      immediate: true,
    },
    city: {
      handler(val) {
        if (val && val.id) {
          this.fetchRegion('dic', val.id);
        }
      },
      immediate: true,
    },
  },
  methods: {
    cancel() {
      this.$emit('cancel');
    },
    confirm() {
      const { province, city, district } = this;
      this.$emit('confirm', {
        province, city, district, gbType: this.nowGbType,
      });
    },
    async fetchProvince() {
      if (this.slots[0].values.length) {
        return;
      }
      const data = await basicsApis.getProvince({ gbType: 1 }); // 修改为获取国标码的地址
      if (Array.isArray(data)) {
        this.slots[0].values = data;
        if (this.isEdit) {
          data.forEach((f, index) => {
            if (f.id === this.data.province.id) {
              this.slots[0].defaultIndex = index;
              this.province = this.data.province;
            }
          });
        }
      }
    },
    async fetchRegion(type, id) {
      const data = await basicsApis.getCity({ parentId: id });
      if (Array.isArray(data)) {
        if (type === 'city') {
          this.slots[2].values = data;
          if (this.isEdit) {
            data.forEach((f, index) => {
              if (f.id === this.data.city.id) {
                this.slots[2].defaultIndex = index;
                this.city = this.data.city;
              }
            });
          }
        } else {
          this.slots[4].values = data;
          if (this.isEdit) {
            data.forEach((f, index) => {
              if (f.id === this.data.district.id) {
                this.slots[4].defaultIndex = index;
                this.district = this.data.district;
              }
            });
            setTimeout(() => {
              this.isEdit = false;
            }, 1000);// isEdit为true只用一次 就是刚打开的时候 不然onCityChange没法继续使用
          }
        }
      }
    },
    onCityChange(picker) {
      if (this.isEdit) { // 如果是编辑状态  刚打开时候 以下为禁用
        return;
      }
      this.province = picker.getSlotValue(0);
      this.city = picker.getSlotValue(1);
      this.district = picker.getSlotValue(2);
      this.nowGbType = 1;
    },
  },

};
</script>

<style lang="scss">
.city-picker {
  width: 100%;

  &__top {
    height: 80px;
    font-size: 28px;
    display: flex;
    align-items: center;
    border: 1px solid #ccc;

    div {
      flex: 1;
      text-align: center;
    }
  }

  &__slot {
    font-size: 26px;
  }
}
</style>
